import { useState } from "react";

import { useStore } from "../store.js";
import { Icon } from "./Icon.js";
import { LedgerSettings } from "./LedgerSettings.js";

export function LedgerMenu() {
  const ledgers = useStore((state) => state.ledgers);
  const currentLedgerId = useStore((state) => state.currentLedgerId);
  const defaultLedgerId = useStore((state) => state.user?.defaultLedgerId ?? null);
  const switchLedger = useStore((state) => state.switchLedger);
  const createLedger = useStore((state) => state.createLedger);
  const renameLedger = useStore((state) => state.renameLedger);
  const deleteLedger = useStore((state) => state.deleteLedger);
  const setDefaultLedger = useStore((state) => state.setDefaultLedger);

  const [open, setOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const current = ledgers.find((ledger) => ledger.id === currentLedgerId);

  return (
    <div className="relative">
      {settingsOpen ? <LedgerSettings onClose={() => setSettingsOpen(false)} /> : null}
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="flex items-center gap-1.5 rounded-lg border border-node-border px-3 py-1.5 text-sm text-ink hover:border-accent"
      >
        <Icon name="stack" size={16} className="text-ink-muted" />
        {current?.name ?? "Ledger"} <span className="text-ink-muted">▾</span>
      </button>

      {open ? (
        <>
          <button
            type="button"
            aria-hidden
            tabIndex={-1}
            className="fixed inset-0 z-10 cursor-default"
            onClick={() => setOpen(false)}
          />
          <div className="absolute left-0 z-20 mt-1 w-56 overflow-hidden rounded-lg border border-node-border bg-node-bg shadow-xl">
            <div className="max-h-64 overflow-y-auto py-1">
              {ledgers.map((ledger) => (
                <button
                  key={ledger.id}
                  type="button"
                  onClick={() => {
                    void switchLedger(ledger.id);
                    setOpen(false);
                  }}
                  className={`flex w-full items-center justify-between gap-2 px-3 py-2 text-left text-sm hover:bg-canvas ${
                    ledger.id === currentLedgerId ? "text-accent" : "text-ink"
                  }`}
                >
                  <span>{ledger.name}</span>
                  {ledger.id === defaultLedgerId ? (
                    <span className="text-xs text-ink-muted" title="Default ledger">
                      default
                    </span>
                  ) : null}
                </button>
              ))}
            </div>

            <div className="border-t border-node-border py-1">
              <button
                type="button"
                onClick={() => {
                  const name = window.prompt("Name your new ledger")?.trim();
                  if (name) {
                    void createLedger(name);
                  }
                  setOpen(false);
                }}
                className="block w-full px-3 py-2 text-left text-sm text-ink hover:bg-canvas"
              >
                New ledger
              </button>
              {current ? (
                <button
                  type="button"
                  onClick={() => {
                    const name = window.prompt("Rename ledger", current.name)?.trim();
                    if (name) {
                      void renameLedger(current.id, name);
                    }
                    setOpen(false);
                  }}
                  className="block w-full px-3 py-2 text-left text-sm text-ink hover:bg-canvas"
                >
                  Rename current
                </button>
              ) : null}
              {current ? (
                <button
                  type="button"
                  onClick={() => {
                    setSettingsOpen(true);
                    setOpen(false);
                  }}
                  className="block w-full px-3 py-2 text-left text-sm text-ink hover:bg-canvas"
                >
                  Settings
                </button>
              ) : null}
              {current && current.id !== defaultLedgerId ? (
                <button
                  type="button"
                  onClick={() => {
                    void setDefaultLedger(current.id);
                    setOpen(false);
                  }}
                  className="block w-full px-3 py-2 text-left text-sm text-ink hover:bg-canvas"
                >
                  Set as default
                </button>
              ) : null}
              {current && ledgers.length > 1 ? (
                <button
                  type="button"
                  onClick={() => {
                    if (window.confirm(`Delete "${current.name}" and everything in it?`)) {
                      void deleteLedger(current.id);
                    }
                    setOpen(false);
                  }}
                  className="block w-full px-3 py-2 text-left text-sm text-warning hover:bg-canvas"
                >
                  Delete current
                </button>
              ) : null}
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}
